var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "cc-titled-panel",
    {
      attrs: {
        title: _vm.talent.Name,
        icon: "cci-rank-" + _vm.rank,
        color: _vm.color,
        dense: ""
      }
    },
    [
      _c(
        "v-icon",
        {
          staticClass: "fadeSelect mt-n5",
          attrs: { slot: "items" },
          on: {
            click: function($event) {
              return _vm.$refs.dialog.show()
            }
          },
          slot: "items"
        },
        [_vm._v("\n    mdi-information-outline\n  ")]
      ),
      _vm._v(" "),
      _c(
        "cc-solo-dialog",
        {
          ref: "dialog",
          attrs: {
            large: "",
            icon: "cci-trait",
            "no-confirm": "",
            title: _vm.talent.Name
          }
        },
        [_c("cc-talent-info", { attrs: { talent: _vm.talent } })],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.ranks, function(tr, i) {
        return _c("cc-talent-rank-item", {
          key: tr.Name,
          attrs: {
            lock: i + 1 > _vm.rank,
            rank: i + 1,
            "talent-rank": tr,
            "action-buttons": _vm.actionButtons,
            small: "",
            color: _vm.itemColor
          }
        })
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }